import tradeable from './tradeable';

export default {
  tradeable,
};
